import { PAGE_LOADER, NAVBAR_ORIENTATION } from "./actionTypes";

const initialState = {
  pageLoader: false,
  accordIndex: "",
  navbarOrientation: "vertical",
};

const globalLists = (state = initialState, action) => {
  switch (action.type) {
    case PAGE_LOADER:
      state = { ...state, pageLoader: action.payload };
      break;

    case NAVBAR_ORIENTATION:
      state = { ...state, navbarOrientation: action.payload };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default globalLists;
